import { useState } from "react";

import styles from "./dataProtectionPage.module.css";
// import Dialog from "../../components/dialog/dialog";
import AppBar from "../../components/appBar/appBar";
import AbortGame from "../../components/abortGame/abortGame";
import PopupWithImage from "../../components/popupWithImage/popupWithImage";
import ImgBuilder from "../../assets/ImgBuilder";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { renderWithLineBreaksAndBold } from '../../functions/renderWithLineBreaksAndBold';
import { useUserData } from '../../functions/updateUserData';

const DataProtectionPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [openDialog, setOpenDialog] = useState(false);
  const { userData, setUserData } = useUserData();

  const [moreInfo, setMoreInfo] = useState(false);

  const nextStep = (actionType) => {
    if (actionType === "confirm") {
      setUserData(prev => ({
        ...prev,
        "data_consent": true
      }));  
      if ((userData.age_group && (userData.age_group !== undefined))){
        navigate("/survey/registration");
      } else{
        // error handling, if somewhy we do not user's age
        navigate("/age");
      }
    } else if (actionType === "cancel") {
      setOpenDialog(true);
    }
  };
  const handleDialogConfirm = () => {
    setOpenDialog(false);
    navigate("/");
  };

  return (
    <div className={styles.dpWrapper}>
      <img alt="bg" className={styles.bgImg} src={ImgBuilder.sbBackground}/>
      <AppBar />
      <AbortGame />
      {openDialog &&
        <PopupWithImage
          name={t("pop_up_notifications.abort_name")}
          description={t("pop_up_notifications.abort_description")}
          button={t("pop_up_notifications.button_terminate")}
          button_exit={t("pop_up_notifications.button_cancel")}
          type={"abortGame"}
          defExit={() => setOpenDialog(false)}
          defContinue={handleDialogConfirm}
        />
      }
      <div className={styles.container}>
        <div className={styles.textContainer}>
          <p className={styles.pageName}>{t("setup.page_name_consent")}</p>
          <p className={styles.mainText}>
            {renderWithLineBreaksAndBold(t("setup.data_protection_main"))}
          </p>
          <div className={styles.moreInfoCon}>
            <button onClick={() => setMoreInfo(!moreInfo)} className={styles.buttonMoreInfo}>{moreInfo ? t("setup.less_info") : t("setup.more_info")}</button>
            <p className={`${styles.moreText} ${moreInfo ? styles.moreTextAct : ''}`}>
              {renderWithLineBreaksAndBold(t("setup.data_protection_additional"))}
            </p>
          </div>
        </div>
      </div>
      <div className={styles.buttonsContainer}>
        <button onClick={() => nextStep("confirm")} className={styles.buttonConsent}>{t("setup.i_consent")}</button>
        <button onClick={() => nextStep("cancel")} className={styles.buttonConsentAbort}>{t("setup.deny")}</button>
      </div>
    </div>

  );
};

export default DataProtectionPage;
